// Module
var code = `<table class="product-list__table table--generate-row-ids table" ng-table-dynamic="\$ctrl.tableConfig with \$ctrl.columns">
  <tbody class="tbody">
  <tr ng-repeat="row in \$data" class="product-list__row">
    <td ng-repeat="col in \$columns">
      <span ng-if="!col.link">{{row[col.field]}}</span>

      <div class="flex-end">
        <a ng-if="col.link"
           class="product-list__column-edit btn btn-warning"
           command-access="{{col.link.access}}"
           ng-href="{{row[col.field]}}">
          {{col.link.label}}
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/product-list/product-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;